import React from 'react';
import { CardContent, CardHeader, CardTitle } from './Card';
import Button from './Button';
import { AlertTriangle } from 'lucide-react';
import Modal from './Modal';

const ConfirmDialog = ({ isOpen, onClose, onConfirm, title = 'Confirm', message, confirmText = 'OK' }) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} className="w-full max-w-md mx-4">
      <CardHeader className="pr-10">
        <CardTitle className="flex items-center text-gray-900">
          <AlertTriangle className="h-5 w-5 mr-2 text-yellow-600" />
          {title}
        </CardTitle>
      </CardHeader>
      <CardContent>
        <p className="text-gray-700 mb-4 whitespace-pre-line">{message}</p>
        <div className="flex justify-end">
          <Button
            variant="outline"
            onClick={() => {
              onConfirm();
              onClose();
            }}
          >
            {confirmText}
          </Button>
        </div>
      </CardContent>
    </Modal>
  );
};

export default ConfirmDialog;
